import Vue from 'vue';
import {
 checkBinding, sendSmsValidate, validateSmsAndBinding, checkSMS, checkIsMember, getMemberCrmInfo, sendBinding, getRecommendStores, getCityDropdown, postBindingGiftUserTag, getBindingGiftCheck
} from '../../../services/crmService/signUpService';
import {
  getStorePersonnel
} from '../../../services/personnelService/storeService';

import {
  getStores
} from '../../../services/storeMapService/storeService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  storeDropdown: [],
  storePersonnelDropdown: [],
  cityDropdown: []
};

// getters
const getters = {};

// actions
const actions = {
  // 驗證綁定狀態
  async checkBindingHandler() {
    const data = await checkBinding();
    return data;
  },
  // 傳送簡訊驗證
  async sendSmsValidateHandler({}, mobile) {
    const data = await sendSmsValidate({ mobile });
    return data;
  },
  // 驗證簡訊驗證碼
  async validateSmsAndBindingHandler({}, validateInfo) {
    const data = await validateSmsAndBinding(validateInfo);
    return data;
  },
  // 檢查簡訊驗證碼
  async checkSMSHandler({}, info) {
    const data = await checkSMS(info);
    return data;
  },
  // 檢查是否已有會員資料
  async checkIsMemberHandler({}, validateInfo) {
    const data = await checkIsMember(validateInfo);
    return data;
  },
  // 取得現有會員資料
  async getMemberCrmInfoHandler({}, mobile) {
    const data = await getMemberCrmInfo(mobile);

    return data;
  },
  // 取得店舖下拉
  async getStoresHandler({ commit }, validateInfo) {
    const data = await getStores(validateInfo);
    commit('setStoreDropdown', data.data);
    return data;
  },
  // 取得店舖顧問
  async getStorePersonnelHandler({ commit }, mobile) {
    const data = await getStorePersonnel(mobile);
    commit('setStorePersonnelDropdown', data.data);
    return data;
  },
  // 客制綁定
  async sendBindingHandler({ commit }, info) {
    const data = await sendBinding(info);
    return data;
  },
  // 取得推薦店舖下拉
  async getRecommendStoresHandler({ commit }, validateInfo) {
    const data = await getRecommendStores(validateInfo);
    const tempArr = [];
    // 按照abc特別抓出來重新排序
    const a = _.findKey(data.data, (val) => val.name === '台北誠品南西');
    if (a) {
      tempArr.push(data.data.splice(a, 1)[0]);
    }
    const b = _.findKey(data.data, (val) => val.name === '台中勤美誠品');
    if (b) {
      tempArr.push(data.data.splice(b, 1)[0]);
    }
    const c = _.findKey(data.data, (val) => val.name === '高雄漢神巨蛋');
    if (c) {
      tempArr.push(data.data.splice(c, 1)[0]);
    }
    data.data = tempArr.concat(data.data);
    commit('setStoreDropdown', data);
    return data;
  },
  // 取得縣市地區下拉
  async getCityDropdownHandler({ commit }, validateInfo) {
    const data = await getCityDropdown(validateInfo);
    commit('setCityDropdown', data);
    return data;
  },
  // 綁定連結紀錄貼標
  async postBindingGiftUserTagHandler({ commit }, input) {
    const data = await postBindingGiftUserTag(input);
    return data;
  },
  // 綁定連結狀態確認
  async getBindingGiftCheckHandler({ commit }, input) {
    console.log(input)
    const data = await getBindingGiftCheck(input);
    return data;
  },
};

// mutations
const mutations = {
  setStoreDropdown(state, data) {
    Vue.set(state, 'storeDropdown', data.data);
  },
  setStorePersonnelDropdown(state, data) {
    Vue.set(state, 'storePersonnelDropdown', Object.keys(data.personnel).map((key) => data.personnel[key]));
  },
  setCityDropdown(state, data) {
    Vue.set(state, 'cityDropdown', data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
